import { AxiosError, AxiosInstance } from 'axios'

import { createAuthedHttpClient } from '@driftt/web-auth'

import config from 'config'
import { captureExceptionWithMessage } from 'utils/logRocket'

const logErrorHandler = (error: AxiosError) => {
  captureExceptionWithMessage('Customer API Error', error, {
    url: window.location.href,
    endpoint: error.config.url,
    errorData: JSON.stringify(error.config)
  })
}

const responseErrorHandlers = [logErrorHandler]

export const CustomerApi: AxiosInstance = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.CUSTOMER_API
  },
  responseErrorHandlers
})
export const toggleUserProperty = async (
  userId: number,
  property: string,
  value: boolean
): Promise<void> => {
  const operation = [
    {
      property,
      operation: 'set',
      value
    }
  ]
  const resp = await CustomerApi.patch(`/users/${userId}/properties2`, operation)
  return resp.data
}

export const setOrgProperty = (
  orgId: number,
  property: string,
  value: any
): Promise<void> => {
  return CustomerApi.patch(`/organizations/${orgId}/properties`, {
    [property]: value
  })
}

export const fetchEndUserData = async (endUserId: string) => {
  return CustomerApi.get(`/end_users/${endUserId}`)
}

export const getPropertyDefinitions = async () => {
  return CustomerApi.get('/property_definitions')
}

export const getDriftProperties = async () => {
  return CustomerApi.get('/contacts/attributes/retrieve/system')
}

export const getSystemProperties = async () => {
  return CustomerApi.get('/contacts/attributes/retrieve/programmatic')
}

export const fetchEndUserTimeline = (endUserId: string, { size = 10 }: Record<any, any>) => {
  return CustomerApi.get(`/end_users/${endUserId}/timeline?size=${size}&filter=CONVERSATION`).then(
    res => res.data
  )
}

export const fetchSalesforceAttributeDefs = () => {
  return CustomerApi.get('/organizations/sidebar/settings').then(res => res.data)
}

export const fetchTeams = () => {
  return CustomerApi.get(`/teams`).then(({ data }) => data)
}

export const fetchCustomerProps = async (userId: number): Promise<void> => {
  return await CustomerApi.get(`/users/${userId}/properties`)
}

export const patchProperties = async (userId: number): Promise<void> => {
  const resp = await CustomerApi.patch(`/users/${userId}/properties2`, [
    {
      property: 'HAS_SEEN_NO_SAVED_VIEWS_NOTIFICATIONS_WARNING',
      operation: 'set',
      value: true
    }
  ])
  return resp.data
}
